import { PropsWithChildren } from 'react';

type MainProps = {
  className?: string;
  style?: any;
  id?: string;
  dataTestId?: string;
};

const Main = ({
  children,
  className,
  dataTestId,
  style,
  ...restProps
}: PropsWithChildren<MainProps>) => {
  if (!children) return null;
  return (
    <main data-testid={dataTestId} className={className} style={style} {...restProps}>
      {children}
    </main>
  );
};

export default Main;
